import { Heading } from '@portal/components'
import React from 'react'

type Props = {
  icon: React.ReactNode
  title: string
  description: string
}
export default function FeatureHighlight({ icon, title, description }: Props) {
  return (
    <div className="flex items-start gap-3">
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-background-surface-secondary text-foreground-normal">
        {icon}
      </div>

      <div>
        <Heading level={4} className="text-base">
          {title}
        </Heading>
        <p className="text-sm text-foreground-subtle">{description}</p>
      </div>
    </div>
  )
}
